import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { getStatusColor } from '../../../../lib/functions';
import { MapMarker } from '../../../../lib/types';
import { LeafletXContent } from '../shared/leaflet-x-content.component';

@Component({
  selector: 'app-leaflet-tooltip-content',
  styleUrls: ['../shared/leaflet-x-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dropdown as-tooltip">
      <div class="dropdown-content">
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>Service</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (
                service of mapMarker()?.services || [];
                track service.name
              ) {
                <tr>
                  <td data-label="Service">
                    {{ service.name }}
                  </td>
                  <td data-label="Status">
                    <div
                      class="flex items-center overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      <svg width="22" height="22" style="margin-right: 5px;">
                        <circle
                          r="10"
                          cx="50%"
                          cy="50%"
                          stroke="black"
                          stroke-width="1"
                          [attr.fill]="serviceStatusColor(service.status)"
                        ></circle>
                      </svg>
                      {{ service.status }}
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `,
})
export class LeafletTooltipContentComponent implements LeafletXContent {
  readonly mapMarker = input<MapMarker>();

  readonly serviceStatusColor = getStatusColor;
}
